export type AppConfigType = {
  api: AppConfigApiType;
  app: AppConfigAppType;
  companyInfo: AppConfigCompanyInfoType;
  googleMaps?: {
    apiKey?: string;
    timezone?: string;
    mapIDs?: { dark: string; light: string };
  };
  theme: AppConfigThemeType;
  serviceLevels: AppConfigServiceLevelsType;
  front: AppConfigFrontType;
  apiKeys?: AppConfigApiKeysType;
  nerdHistory?: NerdHistoryConfigType;
  client?: AppConfigClientType;
};

type AppConfigClientType = {
  contact?: string;
  name?: string;
  support?: string;
  website?: string;
};

type NerdHistoryConfigType = {
  historyKey?: string;
  cookieDomain?: string;
};

type AppConfigApiType = {
  endpoint: string;
  port: number;
  production: boolean;
  routePrefix: string;
  signinRoute: string;
  signoutRoute: string;
  currentUser: string;
  versionCheckerEndpoint: string;
  authServerToken: string;
};

type AppConfigFrontType = {
  publicDomain: string;
  "401Redirect": string;
  hostname: string;
};

type AppConfigAppType = {
  archerAi: boolean;
  proEnabled: boolean;
  perPalletClass: boolean;
  alphaWatermark: boolean;
  favicon: number;
  notFoundImage: string;
  logo: string;
  showPLSignin: boolean;
  showForgotPassword: boolean;
  showSignup: boolean;
  rootBackground: string;
};

type AppConfigCompanyInfoType = {
  contact: string;
  name: string;
  support: string;
  website: string;
};

type AppConfigThemeType = {
  primaryColor: string;
  secondaryColor: string;
};

type AppConfigServiceLevelsType = {
  [name: string]: {
    [name: string]: string;
  };
};

type AppConfigApiKeysType = {
  googleMaps?: {
    apiKey?: string;
    timezone?: string;
    mapIDs?: { dark: string; light: string };
  };
  revenueCat?: string;
  intercom?: string;
  sentry?: string;
  mui?: string;
};

declare global {
  interface Window {
    _APP_CONFIG: AppConfigType;
  }
}

window._APP_CONFIG = window._APP_CONFIG as any;

export const AppConfig = window._APP_CONFIG;
